import React from 'react';
import TimeLineIconSvg from '@sg/assests/svg/timeline-icon.svg';

interface TimeLineIconProps {
  label: string;
}

const TimeLineIcon: React.FC<TimeLineIconProps> = ({ label }) => (
  <div className="ds-timeline-icon">
    <img src={TimeLineIconSvg} alt="timeline icon" />
    <span className="ds-timeline-icon__label">{label}</span>
  </div>
);

export default TimeLineIcon;
